import { wrapLongLabels } from './utils/helpers';
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    colorScale,
    data,
    initialWidth,
    initialHeight,
    margins,
    height,
    width,
    x,
    y,
    xAxis,
    yAxis,
  } = props;

  const yTicks = isMobile ? 5 : 10;
  const [min] = y.domain();

  const ticksMobi = ['2004', '2006', '2008', '2010', '2012', '2014', '2016', '2018', '2020'];

  container.append('ul')
    .attr('class', 'key')
    .selectAll('li')
    .data(colorScale.domain())
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${colorScale(d)};'></span> ${d}`);

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(ticksMobi.map(d => new String(d))));

  xGrid.selectAll('text')
    .attr('y', 10)
    .text(d => (isMobile ? `'${String(d).slice(2)}` : d))
    .call(wrapLongLabels, x.bandwidth());

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width));

  yGrid.selectAll('text')
    .attr('x', -15)
    .filter(d => d === 0 && min >= 0)
    .remove();

  const group = g.append('g')
    .attr('class', 'data');

  const serie = group.selectAll('g')
    .data(data)
    .enter().append('g')
    .style('fill', d => colorScale(d.key))
    .selectAll('g')
    .data(d => d)
    .enter()
    .append('g')
    .attr('class', 'serie')
    .attr('transform', d => `translate(${[x(d.data.label), y(d[1])]})`);

  serie.append('rect')
    .attr('width', x.bandwidth())
    .attr('height', d => y(d[0]) - y(d[1]));

  const text = serie.filter((d) => {
    const y0 = y(d[0]) - y(d[1]);
    const breakpoint = isMobile ? 0.9 : 0.05;
    return y0 > width * breakpoint;
  });

  text.append('text')
    .attr('class', 'value')
    .attr('x', x.bandwidth() / 2)
    .attr('y', d => (y(d[0]) - y(d[1])) / 2)
    .attr('dy', '.35em')
    .text(d => (d[0] < 0 ? `-${d[1] - d[0]}` : d[1] - d[0]));

  if (min < 0) {
    g.append('line')
      .attr('class', 'zero-bar')
      .attr('y1', y(0))
      .attr('y2', y(0))
      .attr('x1', 0)
      .attr('x2', width);
  }
}
